import { render, staticRenderFns } from "./toubu.vue?vue&type=template&id=59f8ac3e&"
import script from "./toubu.vue?vue&type=script&lang=js&"
export * from "./toubu.vue?vue&type=script&lang=js&"
import style0 from "./toubu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports